const METADATA_OVERRIDE_PREFIX = 'METADATA_OVERRIDE_';

/** Parse the Advanced Settings JSON string; returns null unless it's a plain object. */
export const parseMetadataString = (metadataStr: string): Record<string, unknown> | null => {
  if (!metadataStr.trim()) return null;
  try {
    const parsed = JSON.parse(metadataStr);
    if (typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed)) {
      return parsed as Record<string, unknown>;
    }
    return null;
  } catch {
    return null;
  }
};

/**
 * Prefix every key with METADATA_OVERRIDE_ (the backend applies these as conversation
 * metadata overrides) and null out keys sent last time but gone now, so the widget's
 * metadata store drops them.
 */
export const transformMetadataForWidget = (
  metadata: Record<string, unknown>,
  previousKeys: Set<string>,
): { overrideMetadata: Record<string, unknown>; currentKeys: Set<string> } => {
  const overrideMetadata: Record<string, unknown> = {};
  const currentKeys = new Set<string>();
  for (const [key, value] of Object.entries(metadata)) {
    overrideMetadata[`${METADATA_OVERRIDE_PREFIX}${key}`] = value;
    currentKeys.add(key);
  }
  for (const previousKey of previousKeys) {
    if (!currentKeys.has(previousKey)) {
      overrideMetadata[`${METADATA_OVERRIDE_PREFIX}${previousKey}`] = null;
    }
  }
  return { overrideMetadata, currentKeys };
};
